import { UPDATE_ARTICLES} from '../constants'
import store from '../store'

export const updateNewsArticle = articles => store.dispatch({ type: UPDATE_ARTICLES, articles }) 